export default __webpack_public_path__ + "static/media/btn_loyalty.6a4c5aae.png";